import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';

type TableStateRowProps = {
  colSpan: number;
  loading?: boolean;
  error?: string | null;
  emptyMessage?: string;
};

export const TableStateRow = ({
  colSpan,
  loading = false,
  error = null,
  emptyMessage = 'No data available',
}: TableStateRowProps): React.ReactElement => {
  if (loading) {
    return (
      <tr>
        <td colSpan={colSpan} className="px-6 py-12 text-center">
          <div className="flex flex-col items-center justify-center">
            <Loader2 className="h-8 w-8 text-blue-600 animate-spin mb-3" />
            <p className="text-sm text-gray-500">Loading data...</p>
          </div>
        </td>
      </tr>
    );
  }

  if (error) {
    return (
      <tr>
        <td colSpan={colSpan} className="px-6 py-12 text-center">
          <div className="flex flex-col items-center justify-center">
            <AlertTriangle className="h-8 w-8 text-red-500 mb-3" />
            <p className="text-sm text-red-600">{error}</p>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td colSpan={colSpan} className="px-6 py-12 text-center">
        <p className="text-sm text-gray-500">{emptyMessage}</p>
      </td>
    </tr>
  );
};
